import Selector from "components/selector/selector.component";
import React from "react";

import "./company.style.scss";

const Company = ({ client, accountantList, selectedAccountant }) => {
	const company = client.companyType === 0 ? client : client.company;

	const organizedAccountantList = accountantList.map(({ name, surname }) => {
		return name + " " + surname;
	});

	const { color, vatNumber } = company;
	const companyName =
		client.companyType === 0 ? client.name + " " + client.surname : client.company.name;

	return (
		<div className="company-container flex flex--center-items gap-m">
			<div
				className="smooth-corners"
				style={{ aspectRatio: 1, height: "1.8rem", backgroundColor: color }}
			/>
			<p className="w600" style={{ width: "25%" }}>
				{companyName}
			</p>
			<p>{vatNumber}</p>
			<div style={{ width: "30ch", marginLeft: "auto" }}>
				<Selector data={organizedAccountantList} selected={selectedAccountant} />
			</div>
		</div>
	);
};

export default Company;
